import { GLAdjustment } from './glAdjustment.model';

export class PostedClaimGLAdjustment {
  constructor(
    public Client_ClientId: string,
    public RawDataImport_ShardClaimIdentifier: number,
    public GLAdjustments: GLAdjustment[],
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/postedClaimGLAdjustment.model.ts